import { render, staticRenderFns } from "./supplier-staff.vue?vue&type=template&id=33af8544&"
import script from "./supplier-staff.vue?vue&type=script&lang=js&"
export * from "./supplier-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports